import axios from 'axios';
import type { AxiosResponse } from 'axios';

export type PardoSubmitPdfFormData = {
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
};

export const pardotApi = {
  submitPdfForm(endpoint: string, postData: PardoSubmitPdfFormData): Promise<AxiosResponse> {
    // const params = new URLSearchParams(postData);
    // return axios.post(endpoint, params);

    const params = new URLSearchParams(postData);
    // console.log(params, 'params');
    return axios.post(`/api/pardot-form/?url=${endpoint}`, params);
  },
};
